// extracted by mini-css-extract-plugin
export var mainColumnCell = "main-column-cell_lGY_IAdk5TqidjhzYMGZ";
export var mainColumnCellAssigned = "main-column-cell__assigned__uTdsh65UvHN0uQ4LrnO";
export var mainColumnCellGroupRow = "main-column-cell_group-row_TgYrf2Bkdu6rrhDHzMP5";
export var mainColumnCellLabel = "main-column-cell__label_t9rsgoENDKFjIH4KoKh0";